module.exports = __webpack_public_path__ + "static/bg_main_activity-c243bce12e94f4c3577a67c2e5238f57.png";